export default __webpack_public_path__ + "static/ticketDownloadEs-9f08adce1cbe303ef48715acb65120b2.png";